import { REPORTING_TRACKER } from 'reporting-data/constants/usageTracker';
import { getPrimaryTracker } from 'usage-tracker-container';
export function getValidatedPrimaryTracker() {
  let primaryTracker;
  try {
    primaryTracker = getPrimaryTracker(REPORTING_TRACKER);
  } catch (e) {
    console.warn('[ReportCardV2]', e);
  }
  return primaryTracker;
}